/**
 * Safe localStorage access for environments where storage exists but may throw
 * (e.g. iOS private mode, cross-origin iframe). Callers should guard with
 * typeof localStorage !== 'undefined' when needed.
 */

export function safeGetItem(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}
